/**
 * Scroll Reveal - Unified IntersectionObserver module
 * One observer for all reveal animations across the site
 * Supports both static (in HTML) and dynamic (added by JS) elements
 */
var observer = new IntersectionObserver(
  function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  },
  { threshold: 0.15 }
);

function observeRevealElements() {
  var elements = document.querySelectorAll('.js-reveal:not(.is-visible), .js-showcase-block:not(.is-visible)');
  elements.forEach(function (el) {
    observer.observe(el);
  });
}

// Observe static elements
observeRevealElements();

// Re-observe after DOM is fully ready (for dynamically added elements)
document.addEventListener('DOMContentLoaded', observeRevealElements);

export { observeRevealElements };
